import { render, staticRenderFns } from "./AnnuityDetailStatusList.vue?vue&type=template&id=78c455d4&"
import script from "./AnnuityDetailStatusList.vue?vue&type=script&lang=js&"
export * from "./AnnuityDetailStatusList.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityDetailStatusList.vue?vue&type=style&index=0&id=78c455d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports